import ActionHelper from '@module/redux-actions';
import Pending from '@app/store/action/pending';
import API from '@app/api';

export const actions = ActionHelper.types([
  'ERROR_SET',
  'ERROR_RESET',
  'ERRORS_FORM_RESET',
  'VALIDATE_FORM',
]);

export default ActionHelper.generate({
  // This sets the erros in the store for a certain form
  setError: [actions.ERROR_SET, 'form', 'errors'],
  // This resets a single error of a certain form
  resetError: [actions.ERROR_RESET, 'form', 'key'],
  // This resets all errors of a certain form
  resetFormErrors: [actions.ERRORS_FORM_RESET, 'form'],

  validateForm(params = {}, form) {
    if (!form) {
      return;
    }

    const pendingId = 'validation';
    const data = { ...params };

    return async (dispatch, getState) => {
      const { account } = getState();

      // Figure out the right Action to invoke
      // based on form type
      let validateAction = null;
      const pathExtValues = {};
      switch (form) {
        case 'profile':
          validateAction = API.Account.validate;
          break;
        case 'createAccountSubdomain':
          validateAction = API.Account.validateSubdomain;
          break;
        case 'signup':
          validateAction = API.Account.validateSignup;
          break;
        case 'user':
          validateAction = API.User.validate;
          break;
        case 'upgrade':
          validateAction = API.BillingDetails.validateUpgrade;
          break;
        case 'billingDetails':
          validateAction = API.BillingDetails.validate;
          pathExtValues.subscriptionId = account.subscription.id;
          break;
        default:
          return;
      }

      dispatch(Pending.setPending(pendingId));

      try {
        // We do not want to submit a vat_number which is only a prefix.
        if (data.vat_number && data.vat_number.length <= 2) {
          data.vat_number = '';
        }

        await validateAction.call(this, data, {
          pathExtValues: {
            formName: form,
            ...pathExtValues,
          },
        });

        dispatch(this.resetFormErrors(form));
      } catch (error) {
        let errors = {};
        const predicate = {
          signup: (v) => {
            // For the signup-page, we only want return errors for things that are actually submitted
            return data[v] || v === 'country_code';
          },
          account: (v) => {
            // Only return errors if ! current_password
            return typeof data[v] !== 'undefined' && v !== 'current_password';
          },
          billingDetails: (v) => {
            // Only return errors if ! current_password
            return typeof data[v] !== 'undefined' && v !== 'current_password';
          },
          upgrade: (v) => {
            return typeof data[v] !== 'undefined';
          },
        };
        if (predicate[form]) {
          for (const i in error.body.fields) {
            // If the predicate function returns true for the error on this field
            // (ie the field is also defined in the form data and not some other random error)
            // Then add it to the list of errors to show to the user
            if (predicate[form](i)) {
              errors[i] = error.body.fields[i];
            }
          }
        } else {
          errors = error.body.fields;
        }

        dispatch(this.setError(form, errors));
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },

  resetValidationError(form, key) {
    return (dispatch, getState) => {
      const { pending, errors } = getState();

      if (pending.validation) {
        return;
      }

      if (errors[form] && errors[form][key]) {
        dispatch(this.resetError(form, key));

        if (!Object.keys(errors[form]).length) {
          dispatch(this.resetFormErrors(form));
        }
      }
    };
  },
});
